import * as React from 'react';
import { fetchUtils } from 'react-admin';

export interface Options {
    method?: string,
    body?: string,
    headers?: Headers
}

const HttpClient = (url, options: Options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }

    if (localStorage.getItem('swatim_token')) {
        const token = localStorage.getItem('swatim_token');
        options.headers.set('Authorization', `Bearer ${token}`);
    }

    return fetchUtils.fetchJson(url, options);
}

export default HttpClient;